/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_ppm_explanation = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PPM (points-per-million) is calculated as total fantasy points divided by current price. It is the primary metric for value assessment in budget-constrained team building.`)
};

const es_about_ppm_explanation = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PPM (puntos por millón) se calcula como puntos fantasy totales divididos por el precio actual. Es la métrica principal para evaluar el valor en la construcción de equipos con presupuesto limitado.`)
};

const de_about_ppm_explanation = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PPM (Punkte pro Million) wird als Fantasy-Gesamtpunkte geteilt durch den aktuellen Preis berechnet. Es ist die wichtigste Kennzahl zur Wertbewertung beim budgetbeschränkten Teamaufbau.`)
};

const nl_about_ppm_explanation = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PPM (punten-per-miljoen) wordt berekend als het totaal aantal fantasy-punten gedeeld door de huidige prijs. Het is de primaire maatstaf voor waardebeoordeling bij het samenstellen van teams met budgetbeperkingen.`)
};

const fr_about_ppm_explanation = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le PPM (points par million) est calculé comme le total des points fantasy divisé par le prix actuel. C’est la métrique principale pour l’évaluation de la valeur dans la construction d’équipe à budget contraint.`)
};

const it_about_ppm_explanation = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il PPM (punti per milione) è calcolato come punti fantasy totali divisi per il prezzo corrente. È la metrica principale per la valutazione del valore nella costruzione di team a budget limitato.`)
};

const pt_br2_about_ppm_explanation = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PPM (pontos por milhão) é calculado como pontos fantasy totais divididos pelo preço atual. É a métrica principal para avaliação de valor na construção de equipes com restrição de orçamento.`)
};

const pt_about_ppm_explanation = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PPM (pontos por milhão) é calculado como o total de pontos fantasy dividido pelo preço atual. É a métrica principal para avaliação de valor na construção de equipas com orçamento limitado.`)
};

const ja_about_ppm_explanation = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PPM（ポイント・パー・ミリオン）はファンタジーポイント合計を現在の価格で割ったものです。予算制約のあるチーム構築における価値評価の主要指標です。`)
};

const zh_about_ppm_explanation = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PPM（每百万积分）= 总梦幻积分除以当前价格。它是在预算受限的车队构建中评估性价比的主要指标。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_ppm_explanation = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_ppm_explanation(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_ppm_explanation", locale)
	if (locale === "en") return en_about_ppm_explanation(inputs)
	if (locale === "es") return es_about_ppm_explanation(inputs)
	if (locale === "de") return de_about_ppm_explanation(inputs)
	if (locale === "nl") return nl_about_ppm_explanation(inputs)
	if (locale === "fr") return fr_about_ppm_explanation(inputs)
	if (locale === "it") return it_about_ppm_explanation(inputs)
	if (locale === "pt-BR") return pt_br2_about_ppm_explanation(inputs)
	if (locale === "pt") return pt_about_ppm_explanation(inputs)
	if (locale === "ja") return ja_about_ppm_explanation(inputs)
	return zh_about_ppm_explanation(inputs)
};